import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { startLoadingStatisticsSpecialist } from "../../app/actions/statisticActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";

const ID_FORM = "reporter-statistic-specialist";
const OPERATION = "list";

const ListStatisticsSpecialist = () => {
  debugLogPages(':: ListStatisticsSpecialist');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { specialistStatisticList } = useSelector((state) => state.statistic);
  
  useEffect(() => {
    dispatch(startLoadingStatisticsSpecialist());

  }, []);

  debugLogPages(":: specialistStatisticList", {specialistStatisticList});

  return (
    <>
      <NavbarIconsGenericComponent componentName={"specialistStatisticList"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">


          {
            specialistStatisticList && specialistStatisticList.length > 0 &&
            specialistStatisticList.map((row, i) => (
              <div className={`row align-items-center`}>
                  <div htmlFor={row.class} className="col-md-7 tit-view-view tit-content-view-view">
                    {t(`${ID_FORM}.large.${row.class}`)}:
                  </div>
                  <div
                    className="col-md-3 txt-view viewContentTxt"
                    name={row.class}
                    id={row.class}
                  >{row.value}</div>
              </div>
            ))
          }

      </div>

    </>
  );
};

export default ListStatisticsSpecialist;
